// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2gWGl","header":"MergedInvoice_header__3WC62"};